import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PORTRAIT = "/img/jess-portrait.jpg";
const LOGO =
  "https://customer-assets.emergentagent.com/job_session-booking-23/artifacts/q6ceh14a_Jess%20Eisaman%20Co.%20%281%29.png";

const AboutPreview = () => (
  <section
    id="about"
    className="bg-[#F6F1EA] py-16 sm:py-20 border-t border-[#D7B2A3]/30"
    data-testid="about-preview-section"
  >
    <div className="max-w-[1200px] mx-auto px-6 sm:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
      <div className="lg:col-span-5">
        <div className="relative aspect-[3/4] max-w-[400px]">
          <div className="absolute -top-5 -right-5 w-24 h-24 bg-[#B89B63]/30 z-0" />
          <img
            src={PORTRAIT}
            alt="Jess Eisaman — Faith & Identity Coach"
            className="relative z-10 w-full h-full object-cover"
            data-testid="about-preview-portrait"
          />
          <img
            src={LOGO}
            alt="Jess Eisaman Co."
            className="absolute z-20 -bottom-6 -left-6 w-20 h-20 sm:w-24 sm:h-24 bg-[#F6F1EA] p-3 shadow-md object-contain"
          />
        </div>
      </div>

      <div className="lg:col-span-7">
        <h2
          className="font-serif text-4xl sm:text-5xl text-[#4F5D4F] leading-[1.1] tracking-tight"
          data-testid="about-preview-heading"
        >
          Hi, I'm <em className="italic text-[#B89B63]">Jess</em>!
        </h2>

        <div className="mt-8 space-y-5 text-lg text-[#4F5D4F]/85 leading-relaxed font-light max-w-xl">
          <p>
            I'm a <strong className="font-medium text-[#4F5D4F]">Faith &amp; Identity Coach</strong>,
            seminary graduate, former Christian counselor, and{" "}
            <strong className="font-medium text-[#4F5D4F]">ICF-certified coach</strong>.
          </p>
          <p>
            I've personally walked through the work of questioning and rebuilding my own
            faith and identity after growing up within a high-control Christian environment.
            I know what it feels like to look outside yourself for the "right" answer and
            eventually realize you need to learn how to hear and trust your own voice.
          </p>

          <div className="pt-4 border-l-2 border-[#B89B63] pl-6">
            <p className="font-serif italic text-xl sm:text-2xl text-[#4F5D4F] leading-snug">
              I know what it feels like to question and see your world unravel. I know what
              it's like to realize the woman you're becoming doesn't fit inside the life
              and beliefs that once defined you.
            </p>
          </div>

          <p className="pt-3">
            I won't hand you another set of answers. What I can offer is a safe, thoughtful,
            non-prescriptive coaching space—shaped by professional training and lived
            experience—for women navigating these questions.
          </p>
        </div>

        <div className="mt-10">
          <Link
            to="/about"
            className="group inline-flex items-center gap-3 border border-[#4F5D4F] text-[#4F5D4F] hover:bg-[#4F5D4F] hover:text-[#F6F1EA] px-7 py-4 text-xs tracking-eyebrow uppercase transition-colors"
            data-testid="about-preview-cta"
          >
            Meet Jess
            <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default AboutPreview;
